/**
 * @file: 卧柜 update 方法
 * @author: xiaolong.huang@dmall.com
 */

import * as RenderCore from './renderCore';
import Update from '../../update/index';

export default function update(params: ShelfUpdateParams): boolean {
    if (params.onlyUpdateClass) {
        // 货架索引标记class
        RenderCore.addFreezerClass(params.cube);
        return;
    }
    Update.updateDepByCubeId(params.cube.id);
    RenderCore.addFreezerClass(params.cube);

    return true;
}
